import React from 'react';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { translations } from 'src/constants/translations';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  accordionStateOptions, AccordionStateType,
  IMarketplaceFilterTagSelectedValues,
} from 'src/components/profileComponents/Marketplace/types';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { InfoTag } from 'src/components/profileComponents/Marketplace/components/Filters/components/InfoTag';
import { useStyles } from './styles';

interface ITagFilter {
  item: IMarketplaceFilterTagSelectedValues,
  lang: string,
  onDrag?: () => void,
  onTrash?: () => void,
  onChange: (item: IMarketplaceFilterTagSelectedValues) => void,
}

export const TagFilter: React.FC<ITagFilter> = ({
  item, lang, onDrag, onTrash, onChange,
}) => {
  const styles = useStyles();
  return (
    <>
      <GroupWrapper
        name="Tag filter (selected values)"
        startIcon={<FmdGoodOutlinedIcon />}
        actions={(
          <GroupWrapperFiltersAction
            onDrag={onDrag}
            onTrash={onTrash}
          />
        )}
      >
        <div className={styles.tagGroupFields}>
          <BoxFormTextField
            label={translations.name}
            name="name"
            defaultValue={item.name?.[lang]}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'name', lang, event.target.value));
            }}
          />
          <BoxFormAutocomplete
            label={translations.accordionState}
            name="accordionState"
            defaultValue={{ label: item.accordionState, value: item.accordionState }}
            options={accordionStateOptions}
            onChange={(event: {label: string, value: AccordionStateType}) => {
              onChange({ ...item, accordionState: event.value });
            }}
          />
        </div>
        <InfoTag
          item={item.tooltip}
          lang={lang}
          onChange={(tooltip) => onChange({ ...item, tooltip })}
        />
      </GroupWrapper>
    </>
  );
};
